<script>
// Atribuicao/status desativados por enquanto.
// Componente mantido para retomar a logica depois sem reimplementar do zero.
export default {
  name: 'ChatActionsMenu',
  props: {
    conversa: {
      type: Object,
      default: function () {
        return null
      },
    },
  },
}
</script>

<template>
  <div v-if="false" />
</template>
